export default __webpack_public_path__ + "73d4dc4bfedc487f047c3f09daeb6acf.svg";